/**
 *
 * Asynchronously loads the component for CompanyFormPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CompanyFormPage = lazyLoad(
  () => import('./index'),
  module => module.CompanyFormPage,
);
